import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import RoleBasedSource from "./From/RoleBasedSource";
import DateTimeInput from "../../../form/DateTimeInput";
import NewDefault from "./Buttons/NewDefault";
import TillBasedTarget from "./To/TillBasedTarget";
import connect from "react-redux/es/connect/connect";
import Box from "../../../layout/Box";
import TillBasedPos from "./Pos/TillBasedPos";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import {
    DateFormatter,
    optionsTemplate,
    ProductColumn,
    ProductSelect,
    UnitFormatter
} from "../../../../utils/formatters";
import TabContent from "../../../layout/TabContent";
import Tabs from "../../../layout/Tabs";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";
import Select from "../../../form/Select";
import FragmentEditor from "../../FragmentEditor";

const sortable = true;
const filterable = true;

let items = null;

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})((componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons, pool} = props;
    const Editor = props.editor || FragmentEditor;
    const to = (componentProps.props.period || {}).to;
    const from = (componentProps.props.period || {}).from;

    const buttons = <div className="modal-footer with-footer">
        <Fragment>
            {props.values.id ? (Array.isArray(actionButtons) ? actionButtons.map((i) => i) : actionButtons) : null}
            <NewDefault {...componentProps} />
        </Fragment>
    </div>;

    if (
        !(componentProps.till && componentProps.till.pos && componentProps.till.pos.location && componentProps.till.pos.location.store && componentProps.till.pos.location.store.id + "" === "" + componentProps.till.pos.location.store.store)
    ) {
        return <Box header="Hiba" theme="danger">
            "Virtuális" helyen nem lehet pótlást leadni!
        </Box>;
    }
    return <Editor
        theme="default"
    >
        <form onSubmit={props.handleSubmit}>
            <div className="row form-row hidden">
                <TillBasedPos {...componentProps} />
            </div>
            <Tabs
                defaultTab="list"
                theme="default"
                className="modal-tabs"
            >
                <TabContent
                    tabLabel="Lista"
                    tabName="list"
                >
                    <div className="row form-row">
                        <div className="col-md-3">
                            <TillBasedTarget {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, target: "Bolt"}}}} />
                        </div>
                        <div className="col-md-3">
                            <DateTimeInput maxDate={to} value={from} label="Időszak" saveChanges={ (field, value) => componentProps.setState({period: {...componentProps.props.period, from: value}}) }/>
                        </div>
                        <div className="col-md-3">
                            <DateTimeInput minDate={from} value={to} label="&nbsp;" saveChanges={ (field, value) => componentProps.setState({period: {...componentProps.props.period, to: value}}) }/>
                        </div>
                        <div className="col-md-3">
                            <RoleBasedSource {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, source: "Raktár/Bolt"}}}} />
                        </div>
                    </div>
                    {props.values.source && <PoolList {...componentProps} control={{visible: false}} onSourceItemUpdate={componentProps.onSourceItemUpdate} />}
                    {buttons}
                </TabContent>
                <TabContent
                    tabLabel="Kiválasztottak"
                    tabName="selected"
                >
                    <div className="row form-row">
                        <div className="col-md-6">
                            <TillBasedTarget {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, target: "Bolt"}}}} />
                        </div>
                        <div className="col-md-6">
                            <RoleBasedSource {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, source: "Raktár/Bolt"}}}} />
                        </div>
                    </div>
                    <SelectorGrid
                        ref={(grid) => items = grid}
                        {...pool}
                        className="p-small-table"
                        parameters={{...pool.parameters, sortiments: undefined, period: {from: "1901-01-01", to: moment().add(1, 'year').format("YYYY-MM-DD")}}}
                        filter={[{field: "pickedqty", operator: "not isnull"}]}
                        sortBy={[{field: "created_at", direction: "DESC"}]}
                        addRow={<Select
                            storeType="remote"
                            component="Product"
                            placeholder="Termék hozzáadás"
                            objectValue={true}
                            order={{field: "id", direction: "desc"}}
                            view={[...ProductSelect.view,"vat.rate"]}
                            optionsTemplate={optionsTemplate("product")}
                            label={false}
                            openIfHasOptions={true}
                            saveChanges={async (field, product) => {
                                product.product_id = product.id;
                                product.component_id = product.id;
                                product.component_type = "product";
                                delete product.id;
                                await componentProps.onSourceItemUpdate(product, JSON.parse(JSON.stringify({component_id: 0, ...product})));
                                items && items.refresh();
                            }}
                        />}
                        onItemUpdate={async (item, oldItem, field, action) => {
                            return await componentProps.onSourceItemUpdate(item, oldItem, field, action);
                        }}
                    />
                    {buttons}
                </TabContent>
            </Tabs>
        </form>
    </Editor>;
});